import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await login(email, password);
      nav("/dashboard");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Login failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="auth-bg min-h-screen flex" data-testid="login-screen">
      <div className="hidden md:flex flex-1 grid-backdrop relative items-end p-12">
        <div className="relative z-10 max-w-md">
          <span className="inline-flex items-center gap-2 mb-6">
            <span className="w-2 h-2 bg-[#00E5FF]"></span>
            <span className="text-xs uppercase tracking-[0.3em] text-[#8B95A5]">QUANTBRIDGE / TERMINAL</span>
          </span>
          <h1 className="text-4xl font-medium tracking-tight leading-tight">
            Multi-broker AI trading,
            <br />
            <span className="text-[#00E5FF]">with guardrails on.</span>
          </h1>
          <p className="text-sm text-[#8B95A5] mt-4 leading-relaxed">
            Connect Zerodha, Binance, Interactive Brokers, Upstox and Angel One in one cockpit.
            Let the AI agent surface trade ideas — execute them yourself, or let it auto-fire
            within your risk envelope.
          </p>
          <div className="grid grid-cols-3 gap-2 mt-8 text-[10px] uppercase tracking-[0.2em] font-mono text-[#4B5563]">
            <div className="border border-[#272A30] p-3">● 5 brokers</div>
            <div className="border border-[#272A30] p-3">● Stocks + Crypto</div>
            <div className="border border-[#272A30] p-3">● Kill switch</div>
          </div>
        </div>
      </div>

      <div className="flex-1 flex items-center justify-center p-8">
        <form onSubmit={onSubmit} className="panel w-[420px] p-8" data-testid="login-form">
          <h2 className="text-xl font-semibold tracking-tight mb-1">Sign in</h2>
          <p className="text-xs text-[#8B95A5] mb-6">Enter your credentials to access the trading desk.</p>
          <div className="mb-4">
            <label className="label">Email</label>
            <input
              type="email"
              className="field"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              data-testid="login-email"
              autoComplete="email"
            />
          </div>
          <div className="mb-6">
            <label className="label">Password</label>
            <input
              type="password"
              className="field"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              data-testid="login-password"
              autoComplete="current-password"
            />
          </div>
          <button type="submit" disabled={busy} className="btn-primary w-full" data-testid="login-submit">
            {busy ? "Signing in…" : "Enter terminal"}
          </button>
          <div className="text-xs text-[#8B95A5] mt-6 text-center">
            New here?{" "}
            <Link to="/register" className="text-[#00E5FF] hover:underline" data-testid="link-register">Create an account</Link>
          </div>
        </form>
      </div>
    </div>
  );
}
